const config = {
  maxUrlLength: 1500,
  catalog: {
    itemsPerPage: 50,
  },
  timeSeries: {
    maxSelectedLocations: 100,
    // Number of days allowed between queried and returned result dates before displaying warning
    dateRangeConstrainedGraceDays: 0,
    itemsPerPage: 50,
    imageDownloadSizes: [
      { label: '0.3MP', width:  640, height:  480 },
      { label:   '1MP', width: 1280, height:  960 },
      { label:   '2MP', width: 1600, height: 1200 },
      { label:   '5MP', width: 2560, height: 1920 },
    ],
  },
  data: {
    creator: {
      '@type': 'Organization',
      url: 'https://ror.org/00ezrrm21',
      name: 'United States Bureau of Reclamation',
    },
    provider: 'https://data.usbr.gov',
    location: {
      id: 'https://geoconnex.us/usbr/rise/locations/%s',
    },
  },
};

export default config;
